import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Col, Container, Form, Row, Table } from "react-bootstrap";
import { axiosInstance } from "../auth/Auth";
import EmptyTableRow from "./EmptyTableRow";
import LoadingIndicator from "./LoadingIndicator";

export default function SongSearchModal({ show, handleClose, onConfirm, radioId, title = "Song Search", defaultArtist = "", defaultTitle = "" }) {
    const [songSearchData, setSongSearchData] = useState(null);
    const [songSearchFormData, setSongSearchFormData] = useState({ artist: defaultArtist, title: defaultTitle });
    const [selectedSong, setSelectedSong] = useState(null);
    const [, setErrorCode] = useState(null);

    const [songSearchLoading, setSongSearchLoading] = useState(false);

    const handleSongSearchSubmit = async event => {
        event.preventDefault();
        setSongSearchLoading(true);
        try {
            const response = await axiosInstance.get(
                `/items/songs/?radio_id=${radioId}&artist=${encodeURIComponent(songSearchFormData.artist)}&title=${encodeURIComponent(
                    songSearchFormData.title,
                )}`,
            );
            setErrorCode(null);
            setSongSearchData(response.data);
        } catch (error) {
            setSongSearchData(null);
            setErrorCode(error?.response?.status ?? 500);
        }
        setSongSearchLoading(false);
    };

    function handleConfirm() {
        onConfirm(selectedSong);
        handleClose();
        setSelectedSong(null);
    }

    return (
        <Modal size="xl" centered show={show} onHide={handleClose} scrollable onExited={() => setSongSearchData(null)}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row className="gy-3">
                        <Form onSubmit={handleSongSearchSubmit} className={"d-flex col-12 gap-3"}>
                            <Col>
                                <Form.Control
                                    type={"text"}
                                    placeholder={"artist"}
                                    value={songSearchFormData.artist}
                                    className={"mb-1"}
                                    size={"sm"}
                                    onChange={e => setSongSearchFormData({ ...songSearchFormData, artist: e.target.value })}
                                />
                            </Col>
                            <Col>
                                <Form.Control
                                    type={"text"}
                                    placeholder={"title"}
                                    value={songSearchFormData.title}
                                    className={"mb-1"}
                                    size={"sm"}
                                    onChange={e => setSongSearchFormData({ ...songSearchFormData, title: e.target.value })}
                                />
                            </Col>
                            <Col xs={"auto"}>
                                <Button
                                    type="submit"
                                    size={"sm"}
                                    className={"btn-ra-yellow"}
                                    disabled={(songSearchFormData.artist + songSearchFormData.title).length < 3}>
                                    Search
                                </Button>
                            </Col>
                        </Form>
                        <Col className="">
                            {songSearchLoading ? (
                                <span colSpan={12}>
                                    <LoadingIndicator />
                                </span>
                            ) : (
                                songSearchData && (
                                    <Table size="sm" hover className="selectable">
                                        <thead>
                                            <tr>
                                                <th className="col-4">Artist</th>
                                                <th className="col-4">Title</th>
                                                <th className="col-2 text-center">Release Year</th>
                                                <th className="col-2 text-center">Item ID</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {songSearchData.length ? (
                                                songSearchData?.map(song => (
                                                    <tr
                                                        className={selectedSong?.item_id === song.item_id && "active"}
                                                        key={song.item_id}
                                                        onClick={() => setSelectedSong(song)}
                                                        onDoubleClick={handleConfirm}>
                                                        <td>{song.artist}</td>
                                                        <td>{song.title}</td>
                                                        <td className="text-center">{song.release_year ?? "-"}</td>
                                                        <td className="text-center">{song.item_id}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <EmptyTableRow />
                                            )}
                                        </tbody>
                                    </Table>
                                )
                            )}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button className={"btn-ra-yellow"} onClick={handleConfirm} disabled={!selectedSong}>
                    Choose
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
